/**
 * Factory for Invalid Epc error
 *
 * @alias TmrInvalidEpcError
 * @type {ngFactory}
 */
export const factory = [
  'TmrInvalidEpcError',
  /*@ngInject*/ TmrError =>
    class TmrInvalidEpcError extends TmrError {
      constructor(message = 'ERROR.CHECKLISTS.INVALIDEPC', ...params) {
        super(message, ...params)
      }
    },
]
